import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { getUserEmail, getUserName, getAuthError } from 'modules/auth'
import { updateProfile } from 'modules/auth/actions'

class Profile extends PureComponent {
  static propTypes = {
    email: PropTypes.string,
    name: PropTypes.string,
    updateProfile: PropTypes.func.isRequired,
    error: PropTypes.string,
  }

  constructor(...args) {
    super(...args)
    this.state = {
      email: this.props.email,
      name: this.props.name || '',
      currentPassword: '',
      newPassword: '',
      error: this.props.error,
    }
    this.inputValueChanged = this.inputValueChanged.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      email: nextProps.email,
      name: nextProps.name,
      error: nextProps.error,
    })
  }

  inputValueChanged(e) {
    this.setState({ [e.target.name]: e.target.value, error: null })
  }

  saveChanges(e) {
    e.preventDefault()
    const { email, name, currentPassword, newPassword } = this.state
    this.props.updateProfile(email, name, currentPassword, newPassword)
    this.setState({ currentPassword: '', newPassword: '' })
  }

  render() {
    const { email, name, currentPassword, newPassword, error } = this.state

    return (
      <form className="card card-block" onSubmit={ this.saveChanges }>
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
        <div className="form-group row">
          <label htmlFor="email" className="col-sm-3 col-form-label">Email</label>
          <div className="col-sm-9">
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Email"
              name="email"
              value={ email }
              onChange={ this.inputValueChanged }
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="name" className="col-sm-3 col-form-label">Name</label>
          <div className="col-sm-9">
            <input
              type="name"
              className="form-control"
              id="name"
              placeholder="Name"
              name="name"
              value={ name }
              onChange={ this.inputValueChanged }
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="currentPassword" className="col-sm-3 col-form-label">Current Password</label>
          <div className="col-sm-9">
            <input
              type="password"
              className="form-control"
              name="currentPassword"
              value={ currentPassword }
              onChange={ this.inputValueChanged }
              id="currentPassword"
              placeholder="Current Password"
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="newPassword" className="col-sm-3 col-form-label">New Password</label>
          <div className="col-sm-9">
            <input
              type="password"
              className="form-control"
              name="newPassword"
              value={ newPassword }
              onChange={ this.inputValueChanged }
              id="newPassword"
              placeholder="New Password"
            />
          </div>
        </div>
        <div className="form-group row">
          <div className="offset-sm-3 col-sm-9">
            <button type="submit" className="btn btn-primary" disabled={!!error}>Save</button>
          </div>
        </div>
      </form>
    )
  }
}

const mapPropsToState = createStructuredSelector({
  email: getUserEmail,
  name: getUserName,
  error: getAuthError,
})
const mapDispatchToProps = { updateProfile }

export default connect(mapPropsToState, mapDispatchToProps)(Profile)



// WEBPACK FOOTER //
// ./src/components/account/profile.js